var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 764,
    height: 635,
    viewBox: "0 0 764 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.4 367.2L29.2 446.9L110.5 537.2L382.2 634.3L168.4 367.2Z",
    fill: "#17B7E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 446.9L132.9 476.1L168.4 367.2L29.2 446.9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 537.2L132.9 476.1L382.2 634.3L110.5 537.2Z",
    fill: "#F494B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.2 123.5L0.900024 35.8999L26.8 303.8L126.1 391.4L128.5 373.8L382.2 608.6L214.2 123.5Z",
    fill: "#17B7E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.900024 35.8999L151.7 373.1L126.1 391.4L94 409.8L26.8 303.8L0.900024 35.8999Z",
    fill: "#5DDFF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M595.9 367.2L735.1 446.9L653.8 537.2L382.2 634.3L595.9 367.2Z",
    fill: "#126D96"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M653.8 537.2L631.3 476L382.2 634.3L653.8 537.2Z",
    fill: "#17B7E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M550.2 123.5L763.5 35.8999L737.5 303.8L382.2 608.6L550.2 123.5Z",
    fill: "#F494B2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M763.5 35.8999L585.1 434.6L638.2 391.4L670.3 409.8L737.5 303.8L763.5 35.8999Z",
    fill: "#126D96"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M735.1 446.9L631.4 476.1L605.5 397.7L638.2 391.4L735.1 446.9Z",
    fill: "#5DDFF4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M132.9 476.1L107.5 158.9L382.2 0.300049L656.8 158.9L631.4 476.1L382.2 634.5L132.9 476.1Z",
    fill: "#5DDFF4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.9 476.1L107.5 158.9L382.2 0.300049L656.8 158.9L631.4 476.1L382.2 634.5L132.9 476.1Z",
    fill: "#5DDFF4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M382.2 317.5V634.3L631.4 476.1L382.2 317.5Z",
    fill: "#126D96"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M382.2 317.5L132.9 476.1L382.2 634.3V317.5Z",
    fill: "#17B7E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M656.8 158.9L382.2 317.5L631.4 476.1L656.8 158.9Z",
    fill: "#17B7E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M763.5 35.8999L576.5 112.7L382.2 0.5V317.5L656.7 159L656.8 158.9L763.5 35.8999Z",
    fill: "#5DDFF4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M382.2 317.5L107.5 158.9L132.9 476.1L382.2 317.5Z",
    fill: "#5DDFF4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.7 159L382.2 317.5V0.5L187.7 112.7L0.900024 35.8999L107.5 158.9L107.6 159H107.7Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M576.7 112.6L656.7 159L763.5 35.8999L576.7 112.6Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M558.9 197.6L431.3 123.9C416.4 115.3 399.4 110.7 382.2 110.7C365 110.7 348 115.3 333.1 123.9L205.5 197.6C195.5 203.4 189.3 214.1 189.3 225.6V297.1C189.3 322.7 199.8 347.2 218.1 364.9V370.1C218.1 406.6 237.7 440.6 269.2 458.8L382.2 524.1L495.2 458.8C527.6 440.1 545.7 406.8 546.3 364.9C564.7 347.1 575.1 322.7 575.1 297.1V225.6C575.1 214.1 568.9 203.4 558.9 197.6Z",
    fill: "#1C1128"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M382.2 110.7C399.4 110.7 416.4 115.3 431.3 123.9L558.9 197.6C568.9 203.4 575.1 214.1 575.1 225.6V297.1C575.1 322.7 564.6 347.2 546.3 364.9C545.7 406.8 527.7 440.1 495.2 458.8L382.2 524.1L269.2 458.8C237.7 440.6 218.1 406.6 218.1 370.1V364.9C199.7 347.1 189.3 322.7 189.3 297.1V225.6C189.3 214.1 195.5 203.3 205.5 197.6L333.1 123.9C347.9 115.3 364.9 110.7 382.2 110.7ZM382.2 100.7C363.2 100.7 344.5 105.7 328.1 115.2L200.5 188.9C187.4 196.4 179.3 210.5 179.3 225.6V297.1C179.3 323.8 189.8 349.7 208.1 369V370.1C208.1 410.2 229.6 447.5 264.2 467.4L377.2 532.7L382.2 535.6L387.2 532.7L500.2 467.4C534.7 447.5 554.5 412.7 556.2 369.1C574.6 349.8 585.1 323.7 585.1 297V225.5C585.1 210.4 577 196.4 563.9 188.8L436.3 115.1C419.9 105.7 401.2 100.7 382.2 100.7Z",
    fill: "#17B7E2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M250.6 215.3L382.1 291.2L513.6 215.3L412.2 156.8C393.5 146 370.6 146 351.9 156.8L250.6 215.3Z",
    fill: "#B2E83D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M382.2 323.4L227.2 236.2V297.1C227.2 317.2 237.9 335.8 255.3 345.8L256 346.2V370.1C256 393.2 268.2 414.4 288.1 425.9L382.1 480.2L476.1 425.9C496 414.4 508.2 393.2 508.2 362.9V346.2L508.9 345.8C526.3 335.7 537 317.2 537 297.1V236.2L382.2 323.4Z",
    fill: "#5DDFF4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M382.2 323.4V480.2L476.2 425.9C496.1 414.4 508.3 393.2 508.3 362.9V346.2L509 345.8C526.4 335.7 537.1 317.2 537.1 297.1V236.2L382.2 323.4Z",
    fill: "#126D96"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M527.1 253.3V297.1C527.1 313.6 518.2 328.9 504 337.2L503.3 337.6L498.3 340.5V346.3V363C498.3 388.3 488.9 407.1 471.2 417.3L382.2 468.7L293.2 417.3C276.5 407.7 266.1 389.6 266.1 370.2V346.3V340.5L261.1 337.6L260.4 337.2C246.1 329 237.3 313.6 237.3 297.1V253.3L377.4 332.1L382.3 334.9L387.2 332.1L527.1 253.3ZM537.1 236.2L382.1 323.4L227.1 236.2V297.1C227.1 317.2 237.8 335.8 255.2 345.8L255.9 346.2V370.1C255.9 393.2 268.1 414.4 288 425.9L382 480.2L476 425.9C495.9 414.4 508.1 393.2 508.1 362.9V346.2L508.8 345.8C526.2 335.7 536.9 317.2 536.9 297.1V236.2H537.1Z",
    fill: "#17B7E2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M266 340.5L382.2 405.8V417.3L266 351.9V340.5Z",
    fill: "#126D96"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M498.3 340.5L382.2 405.8V417.3L498.3 351.9V340.5Z",
    fill: "#5DDFF4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M412.3 156.8C403 151.4 392.6 148.7 382.2 148.7V291.3L513.7 215.4L412.3 156.8Z",
    fill: "#21BA45"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M382.2 236.2L255.9 218.4L382.2 291.3L508.4 218.4L382.2 236.2Z",
    fill: "#08843A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M382.2 158.7C391 158.7 399.7 161 407.3 165.4L493.7 215.3L382.2 279.7L270.7 215.3L357.1 165.4C364.7 161.1 373.4 158.7 382.2 158.7ZM382.2 148.7C371.8 148.7 361.4 151.4 352.1 156.8L250.7 215.3L382.2 291.2L513.7 215.3L412.3 156.8C403 151.4 392.6 148.7 382.2 148.7Z",
    fill: "#21BA45"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M381.7 11.8999L571.2 121.3L575.5 123.8L580 121.9L632.2 100.4L751.4 51.3999L727.3 300.4L661.4 404.3L655.8 413.1L664.9 418.3L719 449.3L647.7 528.5L381.8 623.6L115.9 528.5L44.6 449.3L98.7 418.3L107.8 413.1L102.2 404.3L36.3 300.4L12.2 51.3999L21.4 55.2L183.7 121.8L188.2 123.7L192.5 121.2L381.7 11.8999ZM381.7 0.300049L187.2 112.6L24.9 46L0.400024 35.8999L26.4 303.8L93.6001 409.8L28.8 446.9L110.1 537.2L381.1 634.1L381.8 634.5L382.5 634.1L653.5 537.2L734.8 446.9L670 409.8L737.2 303.8L763.2 35.8999L628.6 91.2L576.4 112.7L381.7 0.300049Z",
    fill: "#17B7E2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M407.1 26.6001L536.6 101.4V89.8L410.9 17.2L407.1 26.6001Z",
    fill: "#5DDFF4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M733 241.8L727.3 300.5L681.8 372.2C685.6 372.4 689.4 372.7 693.2 372.9L737 303.8L742.6 246.3L733 241.8Z",
    fill: "#5DDFF4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 234.8L30.3 241.4L21.9 154.3L11.7 153.4L19.6 234.8Z",
    fill: "#5DDFF4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2 555.1L174.2 549.5L115.7 528.6L80.7 489.8L69.9 492.6L110 537.2L160.2 555.1Z",
    fill: "#5DDFF4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M587.2 560.8L587.7 550L427.3 607.4L436.4 614.7L587.2 560.8Z",
    fill: "#5DDFF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond2);
export default __webpack_public_path__ + "static/media/diamond-2.ae3a5720a6ed48594efef54249095001.svg";
export { ForwardRef as ReactComponent };